import { useState } from "react";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

const ADMIN_UID = "7jWZ7mwnLKTw50d17XuqgQlZGbu1"; // ← paste your UID here

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [resetMessage, setResetMessage] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      if (cred.user.uid === ADMIN_UID) {
        navigate("/admin");      // ← admin goes here
      } else {
        navigate("/dashboard");  // ← tutors go here
      }
    } catch (err) {
      setError("Invalid email or password.");
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      setResetMessage("Please enter your email above first.");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setResetMessage("Password reset email sent! Check your inbox.");
    } catch (error) {
      setResetMessage("Error sending reset email. Make sure the email is correct.");
    }
  };

  return (
    <div className="login-container">
      <h1>Login</h1>

      <form onSubmit={handleLogin}>

        <div className="login-group">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="login-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button className="login-btn">Login</button>

      </form>

      <button type="button" className="forgot-btn" onClick={handlePasswordReset}>
        Forgot Password?
      </button>

      {resetMessage && <p className="reset-message">{resetMessage}</p>}
      {error && <p className="reset-message">{error}</p>}
    </div>
  );
}